var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "network-error h-center-align" }, [
    _c("h1", [_vm._v("Uh-Oh!")]),
    _vm._v(" "),
    _c("h3", [
      _vm._v("\n    It looks like you're experiencing some network issues, "),
      _c(
        "a",
        {
          attrs: { href: "#" },
          on: {
            click: function($event) {
              return _vm.$router.go(-1)
            }
          }
        },
        [_vm._v("click here")]
      ),
      _vm._v(" to try\n    again.\n  ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }